import { useListItem } from '@floating-ui/react';
import clsx from 'clsx';

/**
 *
 * @param {{
 *   option: { value: string; label: string };
 *   onSelect: (value: string) => void;
 *   activeIndex: number | null;
 *   isSelected: boolean;
 *   getItemProps: Function;
 * }} props
 *
 * @return {JSX.Element}
 */
export function SelectOption({
  option,
  onSelect,
  activeIndex,
  isSelected,
  getItemProps,
}) {
  const { ref, index } = useListItem({ label: option.label });

  const isActive = index === activeIndex;

  return (
    <button
      ref={ref}
      type="button"
      className={clsx(
        'w-full',
        'px-[16px] py-[4px]',
        'text-[16px] leading-normal text-white',
        isSelected && 'font-bold tracking-wide',
        (isActive || isSelected) && 'bg-neutral-800',
        isActive && 'filter brightness-110',
        'transition-colors duration-300',
      )}
      style={{ textAlign: 'start' }}
      {...getItemProps({ onClick: () => onSelect(option.value) })}
    >
      {option.label}
    </button>
  );
}
